// ============================================================
// Braval - Lot Form (shared by Edit and New)
// ============================================================

import React, { useState, useEffect } from 'react';

const EMPTY_LOT = {
    lot_number:    '',
    title:         '',
    description:   '',
    make:          '',
    model:         '',
    year:          '',
    serial_number: '',
    sale_price:    '',
    project_id:    '',
};

export default function LotForm({ initialValues, projects, onSave, isSaving, saveError, pageTitle, onDelete, onCancel }) {
    const [form, setForm] = useState({ ...EMPTY_LOT, ...initialValues });
    const [projectFilter, setProjectFilter] = useState('');

    // Re-sync if initialValues loads asynchronously (edit page)
    useEffect(() => {
        setForm({ ...EMPTY_LOT, ...initialValues });
    }, [initialValues]);

    const handleChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const filteredProjects = projects.filter(p =>
        p.project_name.toLowerCase().includes(projectFilter.toLowerCase())
    );

    const formatProjectOption = (p) => {
        const year = p.auction_date ? new Date(p.auction_date).getFullYear() : '?';
        return `${p.project_name} (${year})`;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(form);
    };

    return (
        <form className="lot-form" onSubmit={handleSubmit}>
            <div className="lot-form-header">
                <h2 className="lot-form-title">{pageTitle}</h2>
            </div>

            <div className="lot-form-grid">

                {/* Title */}
                <div className="filter-group lot-form-full">
                    <label className="filter-label">Title</label>
                    <input
                        type="text"
                        className="filter-input"
                        value={form.title}
                        onChange={(e) => handleChange('title', e.target.value)}
                    />
                </div>

                {/* Description */}
                <div className="filter-group lot-form-full">
                    <label className="filter-label">Description</label>
                    <textarea
                        className="filter-input lot-form-textarea"
                        value={form.description}
                        onChange={(e) => handleChange('description', e.target.value)}
                        rows={4}
                    />
                </div>

                {/* Make */}
                <div className="filter-group">
                    <label className="filter-label">Make</label>
                    <input
                        type="text"
                        className="filter-input"
                        value={form.make}
                        onChange={(e) => handleChange('make', e.target.value)}
                    />
                </div>

                {/* Model */}
                <div className="filter-group">
                    <label className="filter-label">Model</label>
                    <input
                        type="text"
                        className="filter-input"
                        value={form.model}
                        onChange={(e) => handleChange('model', e.target.value)}
                    />
                </div>

                {/* Year */}
                <div className="filter-group">
                    <label className="filter-label">Year (Manufacture)</label>
                    <input
                        type="number"
                        className="filter-input"
                        value={form.year}
                        onChange={(e) => handleChange('year', e.target.value)}
                        min="1900"
                        max="2100"
                    />
                </div>

                {/* Serial Number */}
                <div className="filter-group">
                    <label className="filter-label">Serial Number</label>
                    <input
                        type="text"
                        className="filter-input"
                        value={form.serial_number}
                        onChange={(e) => handleChange('serial_number', e.target.value)}
                    />
                </div>

                {/* Lot Number */}
                <div className="filter-group">
                    <label className="filter-label">Lot Number</label>
                    <input
                        type="text"
                        className="filter-input"
                        value={form.lot_number}
                        onChange={(e) => handleChange('lot_number', e.target.value)}
                    />
                </div>

                {/* Sale Price */}
                <div className="filter-group">
                    <label className="filter-label">Sale Price ($)</label>
                    <input
                        type="number"
                        className="filter-input"
                        value={form.sale_price}
                        onChange={(e) => handleChange('sale_price', e.target.value)}
                        min="0"
                        step="0.01"
                    />
                </div>

                {/* Project Assignment */}
                <div className="filter-group lot-form-full">
                    <label className="filter-label">Project</label>
                    <input
                        type="text"
                        className="filter-input"
                        placeholder="Filter projects..."
                        value={projectFilter}
                        onChange={(e) => setProjectFilter(e.target.value)}
                        style={{ marginBottom: 6 }}
                    />
                    <select
                        className="filter-input lot-form-project-select"
                        value={form.project_id}
                        onChange={(e) => handleChange('project_id', e.target.value)}
                        required
                        size={8}
                    >
                        <option value="">— Select a project —</option>
                        {filteredProjects.map(p => (
                            <option key={p.project_id} value={p.project_id}>
                                {formatProjectOption(p)}
                            </option>
                        ))}
                    </select>
                </div>

            </div>

            {saveError && (
                <div className="lot-form-error">{saveError}</div>
            )}

            <div className="lot-form-actions">
                <div className="lot-form-actions-left">
                    <button type="submit" className="search-button" disabled={isSaving}>
                        {isSaving ? 'Saving...' : 'Save'}
                    </button>
                    {onCancel && (
                        <button type="button" onClick={onCancel} className="search-button auction-back-button">Cancel</button>
                    )}
                </div>
                {onDelete && (
                    <button type="button" onClick={onDelete} className="search-button delete-button">Delete Lot</button>
                )}
            </div>
        </form>
    );
}
